<div class="reports" [resBusySpinner]="isBusy" [message]="isBusyMessage" data-automation-id="reports-modal-container">
    <div class="button-bar"
        [attr.data-automation-id]="node && node.data && node.data.task === 'BULK_SEARCH' ? 'bulk-search-summary-button-container' : 'report-button-container'">
        <!-- Other buttons, most are probably dependent on entity type -->
        <button type="button" class="help-button" data-automation-id="reports-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
        <div *ngIf="node && node.entityType === entityTypes.workFlow" class="workflow-reports">
            <button type="button" data-automation-id="download-workflow-reports-button" class="secondary-button"
                (click)="downloadReport('WORKFLOW','xlsx')" title="Download (.xlsx)"
                [disabled]="workflowButtonsEnabled()" *ngIf="hasDownloadPermission">
                <i class="fa fa-download color-blue-01"></i>Download (.xlsx)
            </button>

            <button type="button" data-automation-id="generate-more-workflow-reports-button"
                class="secondary-button left-margin" (click)="generateReports()" title="Generate More Reports ..."
                [disabled]="workflowButtonsEnabled()">
                <i class="fa fa-plus"></i>Generate More Reports ...
            </button>
        </div>
        <div *ngIf="node && node.entityType !== entityTypes.workFlow" class="reports-except-workflow">
            <div class="reports-data">
                <span class="oldest-report-span"
                    *ngIf="node.entityType !== entityTypes.exportVolume && node.name !== dashboardName"
                    data-automation-id="reports-oldest-report-label">{{oldestReportDate}}</span>

                <span class="export-compare-report-span"
                    *ngIf="node.data && node.data.exportComparison && exportComparisonExportNode && exportComparisonSearchNode"
                    data-automation-id="reports-export-comparison-report-label">Export Comparison Report: Deduplicate
                    Search Results against Export Stream</span>
                <span class="export-compare-data-report-span"
                    *ngIf="node.data && node.data.exportComparison && exportComparisonExportNode && exportComparisonSearchNode"
                    data-automation-id="reports-export-comparison-report-search-result-label">
                    <span class="export-compare-data-report-span-name">Search Result:</span>
                    {{exportComparisonSearchNode}}
                </span>
                <span class="export-compare-data-report-span"
                    *ngIf="node.data && node.data.exportComparison && exportComparisonExportNode && exportComparisonSearchNode"
                    data-automation-id="reports-export-comparison-report-export-node-label">
                    <span class="export-compare-data-report-span-name">Export:</span>
                    {{exportComparisonExportNode}}
                </span>

                <span class="oldest-report-span" *ngIf="node.data && node.data.task === 'BULK_SEARCH'"
                    data-automation-id="bulk-search-report-summary-selected-label">Selected:
                    <span>{{selectedItems()}}</span>
                </span>
            </div>
            <res-custom-checkbox class="enable-reports" *ngIf="node.name === dashboardName && hasPreferencesPermission"
                automationId="enable-dashboard-reports" content="Enable Dashboard Reports"
                [(ngModel)]="commonService.dashboardReportsEnabled" (ngModelChange)="updateDashboardReportsEnabled()">
            </res-custom-checkbox>
            <button type="button" class="secondary-button right-align" data-automation-id="reports-update-button"
                [disabled]="isBusy || reportGenerationInProgress" (click)="update()"><i
                    class="fa fa-refresh update-button-icon"></i>Update</button>
            <button type="button" data-automation-id="bulk-search-report-summary-download-button"
                class="secondary-button right-align"
                *ngIf="node.data && node.data.task === 'BULK_SEARCH' && hasDownloadPermission"
                (click)="downloadReport('SEARCH','csv')" title="Download" [disabled]="isBusy">
                <i class="fa fa-download color-blue-01"></i>Download
            </button>
            <button *ngIf="node.data && node.data.task === 'BULK_SEARCH'" type="button"
                class="secondary-button right-align"
                [title]="isBulkSearchButtonEnabled(false) ? '' : 'Please select two or more query-based searches' "
                data-automation-id="bulk-search-report-summary-run-as-combined-search-button"
                [disabled]="!isBulkSearchButtonEnabled(false) || isBusy" (click)="runAsCombinedSearch()"><i
                    class="fa fa-search-plus"></i>Run As Combined Search ...</button>
            <button *ngIf="node.data && node.data.task === 'BULK_SEARCH' && hasTagsPermission" type="button"
                class="secondary-button right-align" data-automation-id="bulk-search-report-summary-add-tags-button"
                [disabled]="!isBulkSearchButtonEnabled(true) || isBusy" (click)="addTags()">
                <div class="iconContainer">
                    <span class="fa-stack">
                        <i class="iconFirst fa-stack-1x fa fa-tag color-grey-05"></i>
                        <i class="iconSecond fa-stack-1x fa fa-plus color-green-04"></i>
                    </span>
                    <span class="add-tag-label">Add Tags ...</span>
                </div>
            </button>
            <button *ngIf="node.entityType === entityTypes.import && node.name !== 'Imports'" type="button"
                class="secondary-button right-align" data-automation-id="reports-scan-history-button"
                [disabled]="isBusy" (click)="openDetailsModal(detailTypes.SCAN_HISTORY)"><i
                    class="fa fa-history dataset-button-icon"></i>Scan
                History ...</button>
            <button *ngIf="node.entityType === entityTypes.import" type="button" class="secondary-button right-align"
                data-automation-id="reports-exception-details-button" [disabled]="isBusy || exceptionReportsInProgress"
                (click)="openDetailsModal(detailTypes.EXCEPTION_DETAILS_IMPORT)"><i
                    class="fa fa-exclamation-triangle dataset-button-icon"></i>Exception
                Details ...</button>
            <button *ngIf="node.entityType === entityTypes.import && isShortMessageTypeSlack" 
                type="button" class="secondary-button right-align"
                data-automation-id="reports-generate-slack-processing-report-button" 
                [disabled]="isBusy || exceptionReportsInProgress"
                (click)="generateSlackProcessingReport()">
                <div class="iconContainer">
                    <span class="fa-stack">
                        <i class="iconFirst fa-stack-1x fa fa-list-alt"></i>
                        <i class="iconSecond fa-stack-1x fa fa-slack"></i>
                    </span>
                    <span class="btn-label">Generate Slack Processing Report</span>
                </div>
            </button>
            <!-- TODO: Commenting out this button section for now - this button will be handled as part of ECASL-39950 -->
            <!-- <button *ngIf="node.entityType === entityTypes.import && !isShortMessageTypeSlack" type="button" class="secondary-button right-align"
                data-automation-id="reports-generate-data-set-report-button" [disabled]="isBusy || exceptionReportsInProgress"
                (click)="openGenerateDataSetReportModal()">
                <div class="iconContainer">
                    <span class="fa-stack">
                        <i class="iconFirst fa-stack-1x fa fa-list-alt"></i>
                        <i class="iconSecond fa-stack-1x fa fa-download"></i>
                    </span>
                    <span class="btn-label">Generate Data Set Report ...</span>
                </div>
            </button> -->
        </div>
    </div>

    <!-- <div> Optional custom panel goes here </div> -->
    <div
        [ngClass]="[node && node.entityType === entityTypes.workFlow ? 'reports-container-flex' : 'reports-container-scroll']">
        <res-report-panel (openDetailsModal)="openReportDetails($event)" (downloadReport)="downloadFile($event)"
            *ngFor="let report of reports" [report]="report" [workflow]="workflow" [allReports]="reports"
            [handle]="handle"></res-report-panel>
    </div>
    <a download #downloadLink hidden target="_blank"></a>
</div>